import * as React from "react";

export const UpDownArrow = ({
    headingDown,
    className
}: {
    headingDown: boolean;
    className?: string;
}) => {
    return (
        <i
            className={`width-[0.3em] height-[0.3em] relative inline-block border-r-[3px] border-b-[3px] border-current p-[3px]
            ${
                headingDown
                    ? "bottom-[0.1em] rotate-45"
                    : "top-[0.1em] rotate-[-135deg]"
            } ${className}`}
        ></i>
    );
};

export const LeftRightArrow = ({
    headingLeft,
    className
}: {
    headingLeft: boolean;
    className?: string;
}) => {
    return (
        <i
            className={`relative inline-block origin-center border-r-[3px] border-b-[3px] border-current p-[0.2em]
                ${
                    headingLeft
                        ? "left-[0.1em] rotate-[135deg]"
                        : "right-[0.1em] rotate-[-45deg]"
                } ${className}`}
        ></i>
    );
};
